import React from "react";

function Erp() {
  return (
    <>
      <section className="services" id="erp">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>Our Services</h2>
              </div>

              <h4 className="text-color">
                <h3>
                  <b>Custom ERP</b>
                </h3>
                <p>
                  <h5 className="text-color">
                    <b>
                      Do you know - 50% of standard ERP projects fail for first
                      time!
                    </b>
                  </h5>
                </p>
              </h4>

              <p>
                At Macrozion Tech Systems, we design and customize enterprise
                resource planning (ERP) systems for all types of businesses. Our
                experts can integrate third-party software to improve your
                existing system or build one from the scratch. These solutions
                have helped clients to automate their business processes,
                improve cross-organizational collaboration, utilize data
                effectively, and above all-gain a competitive edge!{" "}
              </p>
            </div>

            <div className="col-md-8">
              <b>ERP Development:</b>{" "}
              <p>
                With a cumulative business experience of over 20 years across
                industries, we can easily develop scalable and robust
                enterprise-wide ERP systems for your mobile, web, and on-premise
                platforms.
              </p>
              <b>ERP Customization:</b>{" "}
              <p>
                Our experts combine their technology expertise with industry
                best practices to develop an ERP solution that can be integrated
                with enterprise-wide software and CRM to meet your business
                needs.
              </p>
              <b>ERP Implementation:</b>{" "}
              <p>
                We can easily configure and deploy custom ERP solutions across
                your organization while assuring consistency, performance, and
                data security.
              </p>
              <b>ERP Migration:</b>{" "}
              <p>
                Our experts follow proven migration methodologies and adopt a
                phased and systematic approaches during data migration between
                multiple systems. This allows us to assure high accuracy,
                completeness, and efficiency.
              </p>
              <b>ERP Support and Maintenance:</b>{" "}
              <p>
                We provide user-oriented and solutions-driven support services
                to resolve the issues that may affect ERP functioning. We
                provide a wide range of ERP support and maintenance services
                such as post-implementation support, monitoring and maintenance
                of ERP app and backend servers, and patch updates.
              </p>
            </div>

            <div className="col-md-4">
              <p>
                <img
                  src="./images/erp.png"
                  alt="Example1"
                  width="420"
                  height="320"
                ></img>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Erp;
